<template>
  <b-card no-body >
    <div style="display:block" id="listaPreebarque">
      <b-card-body>
        <div class="d-flex justify-content-between  flex-wrap">
          <!-- Registar Preembarque  -->
          <b-form-group
              label-for="filterInput"
              class="mb-0"
          >
            <b-button
                variant="gradient-primary"
                size="sm"
                class="mr-1"
                @click="listarPreembarques"
            >
              <feather-icon
                  icon="RefreshCwIcon"
              />
            </b-button>

            <b-button
                variant="gradient-success"
                size="sm"
                @click="descargarFile()"
            >
              <feather-icon
                  icon="PlusIcon"
                  class="mr-50"
              />
              <span class="align-middle">Exportar</span>
            </b-button>
          </b-form-group>
          <!-- filter -->
          <b-form-group
              label-for="filterInput"
              class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Buscar"
              />
              <b-input-group-append>
                <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                >
                  Borrar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

        </div>
      </b-card-body>

      <b-table
          hover
          responsive
          class="position-relative"
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="cPaginacion"
      >
        <template #cell(estado_registro)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>

        <template #cell(acciones)="data">
          <div class="text-nowrap">
            <feather-icon
                :id="`btn_${data.item.id}_editar`"
                icon="EyeIcon"
                size="16"
                class="text-info mx-1"
                @click="mostrarModal(data.item.id,data.item.nombres_cliente,data.item.numero_operacion)"
            />
            <b-tooltip
                title="Ver pallet"
                variant="info"
                :target="`btn_${data.item.id}_editar`"
            />

          </div>
        </template>

      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
            label="Mostrar"
            label-cols="5"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
              id="perPageSelect2"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
          />

        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </div>

    <div style="display:none" id="listaPallets">

      <div class="d-block text-center">
        <div style="height: 100%">
          <b-card-body>
            <div class="d-flex justify-content-between  flex-wrap">
              <!-- Registar Preembarque  -->
              <b-form-group
                  label-for="filterInput"
                  class="mb-0"
              >
                <b-button
                    variant="gradient-danger"
                    size="sm"
                    class="mr-1"
                    @click="regresarInicio"
                >
                  <feather-icon
                      icon="ArrowLeftIcon"
                  />
                  Regresar
                </b-button>

                <b>Lista de Pallets</b>
              </b-form-group>
              <!-- filter -->
              <b-form-group
                  label-for="filterInput"
                  class="mb-0"
              >
                <div id="clientecontent" >
                  <b>MULTISERVICIOS GENERALES L & V S.A.C. - N° OPERACIÓN [1772-VHJ] </b>
                </div>

              </b-form-group>

            </div>
          </b-card-body>
          <b-table
              hover
              responsive
              class="position-relative"
              :per-page="perPage"
              :current-page="currentPage"
              :items="itemsPallets"
              :fields="fieldsPallets"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="cPaginacion"
          >

            <template #cell(fotografia_temperatura_pulpa_estado)="data" >
              <div v-if="data.item.fotografia_temperatura_pulpa_estado === 'SI'">
                <div class="text-nowrap">
                  <feather-icon
                      :id="`btn_${data.item.id}_ver`"
                      icon="ImageIcon"
                      size="16"
                      class="text-info mx-1"
                      @click="verImagenPulpa(data.item.fotografia_temperatura_pulpa_archivo)"
                  />
                </div>
              </div>
              <div style="color: red" v-else >
                NO
              </div>


            </template>
            <template #cell(fotografia_pallet_estado)="data">
              <div v-if="data.item.fotografia_pallet_estado === 'SI'">
                <div class="text-nowrap">
                  <feather-icon
                      :id="`btn_${data.item.id}_ver`"
                      icon="ImageIcon"
                      size="16"
                      class="text-info mx-1"
                      @click="verImagenPallet(data.item.fotografia_pallet_archivo)"
                  />
                </div>
              </div>
              <div style="color: red" v-else >
                NO
              </div>

            </template>


          </b-table>
          <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
            <!-- page length -->
            <b-form-group
                label="Mostrar"
                label-cols="5"
                label-align="left"
                label-size="sm"
                label-for="sortBySelect"
                class="text-nowrap mb-md-0 mr-1"
            >
              <b-form-select
                  id="perPageSelect3"
                  v-model="perPage"
                  size="sm"
                  inline
                  :options="pageOptions"
              />

            </b-form-group>

            <!-- pagination -->
            <div>
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  first-number
                  last-number
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mb-0"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </b-card-body>
        </div>
      </div>

    </div>


      <b-modal id="modalPopover" ok-only  v-model="estadoModal"  size="sm"  :title="infoModal.title"  hide-footer>

        <b-card

        >
          <img :src="src" class="img-fluid" alt="..." >
        </b-card>

      </b-modal>




  </b-card>
</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol
} from 'bootstrap-vue'
import axios from "axios";

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {

      perPage: 10,
      pageOptions: [5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      estadoModal: false,
      src: '',
      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        {
          key: 'nombres_responsable',
          label: 'Responsable',
          sortable: true
        },
        {
          key: 'dni_responsable',
          label: 'DNI Responsable',
          sortable: true
        },
        {
          key: 'fecha_inspeccion_f',
          label: 'Fecha Insepección',
          sortable: true
        },
        {
          key: 'hora_inspeccion',
          label: 'Hora Inspección',
          sortable: true
        },
        {
          key: 'fecha_despacho_f',
          label: 'Fecha Despacho',
          sortable: true
        },
        {
          key: 'documento_cliente',
          label: 'Codigo Cliente',
          sortable: true
        },
        {
          key: 'nombres_cliente',
          label: 'Cliente',
          sortable: true
        },
        {
          key: 'nombres_productor',
          label: 'Productor',
          sortable: true
        },
        {
          key: 'destino',
          label: 'Destino',
          sortable: true
        },
        {
          key: 'numero_operacion',
          label: 'Número Operación   ',
          sortable: true
        },
        {
          key: 'cultivo',
          label: 'Cultivo',
          sortable: true
        },
        {
          key: 'tipo_embarque',
          label: 'Tipo Embarque',
          sortable: true
        },
        {
          key: 'estado_registro',
          label: 'Estado',
          sortable: true
        },
        {
          key: 'acciones'
        },
      ],
      fieldsPallets: [
        {
          key: 'numero_pallet',
          label: 'Número',
          sortable: true
        },
        {
          key: 'hora',
          label: 'Hora',
          sortable: true
        },
        {
          key: 'temperatura_pulpa',
          label: 'Temperatura',
          sortable: true
        },
        {
          key: 'presentacion',
          label: 'Presentación',
          sortable: true
        },
        {
          key: 'numero_caja',
          label: 'Caja',
          sortable: true
        },
        {
          key: 'etiquetado',
          label: 'Etiquetado',
          sortable: true
        },
        {
          key: 'parihuela',
          label: 'Parihuela',
          sortable: true
        },
        {
          key: 'esquineros',
          label: 'Esquineros',
          sortable: true
        },
        {
          key: 'zunchos',
          label: 'Zunchos',
          sortable: true
        },
        {
          key: 'pallet_ship',
          label: 'Pallet ship',
          sortable: true
        },
        {
          key: 'malla',
          label: 'Malla',
          sortable: true
        },
        {
          key: 'conformidad',
          label: 'Conformidad',
          sortable: true
        },
        {
          key: 'fotografia_temperatura_pulpa_estado',
          label: 'Foto Pulpa',
          sortable: true
        },
        {
          key: 'fotografia_pallet_estado',
          label: 'Foto Pallet',
          sortable: true
        },
        {
          key: 'observaciones',
          label: 'Observaciones',
          sortable: true
        },
      ],
      items: [],
      itemsPallets: [],
      status: [
        {
          1: 'Activo',
          0: 'Inactivo',
        },
        {
          1: 'light-success',
          0: 'light-danger',
        }
      ],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.listarPreembarques();
  },
  methods: {
    listarPreembarques(){
      var yo = this

      var config = {
        method: 'get',
        url: '/calidad/preembarque/listAll/'
      };

      axiosIns(config)
      .then((response) => {
          yo.items = response.data.response;
        yo.totalRows = yo.items.length
        //console.log(yo.items);
      })
      .catch(function (error) {
        console.log(error);
      });
    },

    listarPallets(id,cliente,numero_operación){

      const div1 = document.querySelector('#listaPreebarque');
      const div2 = document.querySelector('#listaPallets');
      const divCliente = document.querySelector('#clientecontent');
      if (div1.style.display === "block") {
        div1.style.display = "none";
        div2.style.display = "block";
      }
      divCliente.innerHTML=""
      divCliente.innerHTML="<b>"+cliente+"  -  N° OPERACIÓN ["+ numero_operación+"]</b>"

      var yo = this

      var config = {
        method: 'get',
        url: '/calidad/controcargapallet/listAll/byid/?codigo_embarque='+id
      };

      axiosIns(config)
          .then(function (response) {
            yo.itemsPallets = response.data.response;
            yo.totalRows = yo.itemsPallets.length
            console.log(yo.itemsPallets);
          })
          .catch(function (error) {
            console.log(error);
          });
    },

    cPaginacion(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    mostrarModal(id,cliente,numero_operación){

      this.listarPallets(id,cliente,numero_operación);

    },
    regresarInicio(){
      const div1 = document.querySelector('#listaPreebarque');
      const div2 = document.querySelector('#listaPallets');
      if (div1.style.display === "none") {
        div1.style.display = "block";
        div2.style.display = "none";
      }
    },

    verImagenPulpa(url){
      this.estadoModal = true;
      this.infoModal.title = "Fotografía de Temperatura Pulpa";
      var urlImagenPul = "http://prd-cloud.agvperu.com/media/"+url;
      this.src= urlImagenPul;


    },

    verImagenPallet(url){
      this.estadoModal = true;
      this.infoModal.title = "Fotografía de Pallet";

      var urlImagenPa = "http://prd-cloud.agvperu.com/media/"+url;

      this.src= urlImagenPa;
    },

    descargarFile(){
      var yo = this

      var config = {
        method: 'GET',
        url: '/calidad/preembarque/exportAll/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer'
      };
      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              console.log("Enviado")

              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Lista de preembarques.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Archivo creado',
                  icon: 'CheckIcon',
                  text: 'El archivo se creó satisfactoriamente.',
                  variant: 'success',
                },
              },
                  {
                    position: 'top-center',
                  })
            }
            else if(response.status === 204){
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'No existen registros',
                  icon: 'AlertTriangleIcon',
                  text: 'No se encontraron registros con los parámetros solicitados.',
                  variant: 'warning',
                },
              })
            }

          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          });


    },

    mostrarNotificacion(titulo, icono, texto, variante){
      this.$toast({
        component: ToastificationContent,
        props:{
          title: titulo,
          icon: icono,
          text: texto,
          variant: variante
        }
      },
      {
        timeout: 5000
      })
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.boton = ''
      this.estadoModal = false
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
